import palette from 'components/palette'
import React from 'react'

type IconSizesType = 'sm' | 'md' | 'lg'

type IconComponentProps = {
  children: JSX.Element
  color?: keyof typeof palette
  size?: IconSizesType
}

const iconSizes: Record<IconSizesType, string> = {
  lg: '36px',
  md: '24px',
  sm: '16px'
}

const Icon = ({ children, color = 'grey800', size = 'md' }: IconComponentProps) => {
  const fill = palette[color]

  return React.cloneElement(children, {
    fill,
    style: { boxSizing: 'border-box', height: iconSizes[size], width: iconSizes[size] }
  })
}

export default React.memo(Icon)
